import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/comforts.php';

export function getComforts() {

    const response = api.get(service_path);

    return response;
};

export function getComfortDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createComfort(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateComfort(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Conforto editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteComfort(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Conforto deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse conforto!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};